import React from 'react';

function Autoplay({ autoplayHook, carouselState }) {
  const { autoplayIsPlaying, toggleAutoplay } = autoplayHook;
  const {
    hasPlayButton, hasItemsToScroll, getPlayElement, getPauseElement,
  } = carouselState;

  if (!hasPlayButton || !hasItemsToScroll) {
    return null;
  }

  const playElement = getPlayElement();
  const pauseElement = getPauseElement();

  return (
    <div className="mn_carouselAutoplay">
      <button
        className={`mn_autoplayButton ${autoplayIsPlaying ? 'mn_pause' : 'mn_play'}`}
        onClick={toggleAutoplay}
        type="button"
        aria-label={autoplayIsPlaying ? 'Click to pause carousel' : 'Click to play carousel'}
      >
        {autoplayIsPlaying ? pauseElement : playElement}
      </button>
    </div>
  );
}

export default Autoplay;
